import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import emailjs from "emailjs-com";
import { toast } from "react-toastify";

const Contact = () => {
    const [form, setForm] = useState({ Name: "", Mobile: "", Email: "", Message: "" });

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .send(
                "service_yb3k31k",
                "template_c57ipnh",
                form,
                "oUe5Px_prYF6Tyu0Y"
            )
            .then(() => {
                toast.success("Form Submit Successfully Admin will contact you soon!", {
                    position: "top-center"
                });
            }
            )
            .catch((err) => console.log(err));
    };

    return (
        <>
            {/* <!-- Breadcromb Area Start --> */}
            <section className="bleezy-breadcromb-area">
                <div className="breadcromb-top section_50">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-top-text">
                                    <h2>contact us</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcromb-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-bottom-text">
                                    <ul>
                                        <li><a href="index-2.html">home</a></li>
                                        <li><a href="#"><i className="fa fa-long-arrow-right"></i></a></li>
                                        <li>Contact Us</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Breadcromb Area End --> */}



            {/* <!-- Contact Page Area Start --> */}
            <section className="bleezy-contact-page-area section_b_70">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-sm-6">
                            <div className="single-contact-address">
                                <h3>ADMIN OFFICE</h3>
                                <ul>
                                    <li>
                                        <i className="fa fa-map-marker"></i>
                                        <p>A.J.L Nehru Road
                                            Kolkata(West Bengal) -700013
                                        </p>

                                    </li>
                                    <li>
                                        <i className="fa fa-phone"></i>
                                        <p>+91 9721336714
                                        </p>
                                    </li>
                                    <li>
                                        <i className="fa fa-envelope-o"></i>
                                        <p>info@octopusssecurity.com</p>
                                        <p style={{ visibility: 'hidden' }}>
                                            A.J.L Nehru Road Kolkata(West Bengal) -700013
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-6">
                            <div className="single-contact-address">
                                <h3>REGISTERED OFFICE</h3>
                                <ul>
                                    <li>
                                        <i className="fa fa-map-marker"></i>
                                        <p>Mishra Sadan , 26A/13 C Muir Road, Saraswatipuram Colony, Rajapur ( Beside Chandra Guest House), Prayagraj(UP)-211002</p>
                                    </li>
                                    <li>
                                        <i className="fa fa-phone"></i>
                                        <p>+91 9454311900</p>
                                    </li>
                                    <li>
                                        <i className="fa fa-envelope-o"></i>
                                        <p>info@octopusssecurity.com</p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* <!-- Contact Page Area End --> */}



            {/* <!-- Contact Form Area Start --> */}
            <section className="bleezy-contact-form-area section_b_100">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="contact-form">
                                <div className="contact-heading">
                                    <h3>Reach Out to Us</h3>
                                    <p>Our experts will reply you very soon</p>
                                </div>
                                <form onSubmit={sendEmail}>
                                    <div className="row">
                                        <div className="col-md-4 col-sm-4">
                                            <p>
                                                <input type="text" name="Name" placeholder="Your Name"
                                                    onChange={(e) => setForm({ ...form, Name: e.target.value })}
                                                    required={true}

                                                />
                                            </p>
                                        </div>
                                        <div className="col-md-4 col-sm-4">
                                            <p>
                                                <input type="email" name="Email" placeholder="Your Email"
                                                    onChange={(e) => setForm({ ...form, Email: e.target.value })}
                                                    required={true}
                                                />
                                            </p>
                                        </div>
                                        <div className="col-md-4 col-sm-4">
                                            <p>
                                                <input type="tel" name="Mobile" placeholder="Your Mobile Number"
                                                    onChange={(e) => setForm({ ...form, Mobile: e.target.value })}
                                                    required={true}
                                                />
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <p>
                                                <textarea name="Message" placeholder="Write Your Message"
                                                    onChange={(e) => setForm({ ...form, Message: e.target.value })}
                                                ></textarea>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="contact-form-button">
                                                <button type="submit" name="submit" >Send message</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Contact;
